import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { orgListConsents } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link2 } from "lucide-react";

// Banner shown to a logged-in user who has a pending request to be coupled to a
// tax-advisor (Steuerberater) account. Links to the consent confirmation page.
export default function ConsentBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [consents, setConsents] = useState([]);

  useEffect(() => {
    let active = true;
    if (!user || user.role === "admin") return undefined;
    orgListConsents()
      .then((c) => {
        if (active) setConsents(c || []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [user]);

  if (!consents.length) return null;
  const c = consents[0];
  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900" data-testid="consent-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-2 text-sm">
        <Link2 className="h-4 w-4 shrink-0" />
        <span className="min-w-0">
          <strong>{c.inviter_name}</strong> möchte Ihr Konto als {c.role_label} verknüpfen.
        </span>
        <button
          onClick={() => navigate(`/verknuepfung?token=${c.token}`)}
          className="ml-auto font-medium underline shrink-0"
          data-testid="consent-banner-review"
        >
          Prüfen
        </button>
      </div>
    </div>
  );
}
